import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PRODUCT_KEY_CONSTANT,
  DESTINATION_KEY_CONSTANT,
  LOGIN_OBJECT_KEY_CONSTANT,
  DEFAULT_ROUTE_CONSTANT,
  PREVIOUS_DESTINATION_KEY_CONSTANT,
  SIGNOUT_ROUTE,
} from '../constants/routes.constant';
import { SESSION_TOKEN_KEY } from "../constants/local-storage.constant";
import {UserProfileService} from "../services/user-profile.service";
import {IUserProfile} from "../interfaces/i-user-profile.interface";

@Component({
    selector: 'app-login-successful',
    templateUrl: './login-successful.component.html',
    styleUrls: ['./login-successful.component.scss'],
    standalone: false
})
export class LoginSuccessfulComponent {
  public userDetails!: IUserProfile;
  public productName!: string;
  private destination!: string;
  private loginObject!: string;
  private previousDestination!: string;
  private productNameKey: string = PRODUCT_KEY_CONSTANT;
  private destinationKey: string = DESTINATION_KEY_CONSTANT;
  private loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  private previousDestinationKey: string = PREVIOUS_DESTINATION_KEY_CONSTANT;
  private queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
    [this.previousDestinationKey]: this.previousDestination,
  };

  constructor(
    private readonly userProfileService: UserProfileService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.productNameKey = 'productName';
    this.destinationKey = 'dst';

    this.productName = atob(
      this.activatedRoute.snapshot.queryParamMap.get(this.productNameKey)!
    );
    this.destination = atob(
      this.activatedRoute.snapshot.queryParamMap.get(this.destinationKey)!
    );
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
      this.loginObjectKey
    )!;
    this.previousDestination = this.activatedRoute.snapshot.queryParamMap.get(
      this.previousDestinationKey
    )!;

    this.queryParams = {
      [this.productNameKey]: this.productName,
      [this.destinationKey]: this.destination,
      [this.loginObjectKey]: this.loginObject,
      [this.previousDestinationKey]: this.previousDestination,
    };

    if (!this.productName || !this.destination) {
      this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
        queryParams: this.queryParams,
        queryParamsHandling: 'preserve',
      });
    }

    this.getUserDetails();
  }

  public goToDestination() {
    const path = this.destination;
    const sessionToken = localStorage.getItem
    (SESSION_TOKEN_KEY);
    const finalPath = path + "?sessionToken=" + sessionToken;

    // window.location.assign(path + "?sessionToken=" + sessionToken);
    window.location.replace(finalPath);
  }

  public getUserDetails() {
    const raw = localStorage.getItem(SESSION_TOKEN_KEY);

    if (!raw || raw === '') {
      this.router.navigate(['/', ...SIGNOUT_ROUTE.split('/')], {
        queryParams: this.queryParams,
        queryParamsHandling: 'preserve',
      });

      return;
    }

    this.userProfileService
      .getMyProfileDetails()
      .subscribe({
        next: (data) => {
          this.userDetails = data;
        },
        error: (error) => {
          console.error(error);

          localStorage.removeItem(SESSION_TOKEN_KEY);

          this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
            queryParams: this.queryParams,
            queryParamsHandling: 'preserve',
          });
        },
      });
  }
}
